/**
 * AT Javascript Library - Common v1.0.0-alpha
 * Copyright 2023 Association Technologies
 * Author: Ed Sirijintakarn
 */
/**
 * Returns the value of a querystring parameter.
 * @param key - {string} The parameter name.
 * @param url - (optional) {string} The url to parse.
 * @returns The querystring parameter value as a string. If it does not exist, then an empty string is returned.
 */
export function getQueryString(key, url = window.location.href) {
    key = key.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + key + "(=([^&#]*)|&|#|$)", "i"), results = regex.exec(url);
    if (!results)
        return "";
    if (!results[2])
        return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
/**
 * Creates a GUID.
 * @returns a GUID as a string.
 */
export function createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        let r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Formats a string based off of a template.
 * @param template - {string} The format template. Use {#} for replacements.
 * @returns The formatted result as a string.
 */
export function formatString(template) {
    let str = template;
    if (arguments.length) {
        let t = typeof arguments[0];
        let key;
        let args = "string" === t || "number" === t ? Array.prototype.slice.call(arguments, 1) : arguments[0];
        for (key in args) {
            str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
        }
    }
    return str;
}
/**
 * Determines if a JSON object is empty.
 * @param obj - {JSON object} The object to evaluate.
 * @returns True, if the object is empty. Otherwise, false.
 */
export function isEmptyJsonObject(obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}
//# sourceMappingURL=common.js.map